import { Injectable } from "@angular/core";
import { ErrorClass } from "@models/index";
import { Observable, Subject } from "rxjs";

@Injectable({
	providedIn: "root"
})
export class ApiErrorBusService {
	private errorSubject = new Subject<ErrorClass>();
	private aml5ErrorSubject = new Subject<void>();
	private aaErrorSubject = new Subject<void>();

	public get errorReceived(): Observable<ErrorClass> {
		return this.errorSubject.asObservable();
	}

	public broadcast(err: ErrorClass): void {
		this.errorSubject.next(err);
	}

	public get aml5ErrorReceived(): Observable<void> {
		return this.aml5ErrorSubject.asObservable();
	}

	public broadcastAML5Error(): void {
		this.aml5ErrorSubject.next();
	}

	public get aaErrorReceived(): Observable<void> {
		return this.aaErrorSubject.asObservable();
	}

	public broadcastAAError(): void {
		this.aaErrorSubject.next();
	}
}
